import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/components/_navbar.scss';
import logo from '../images/HD LOGO/New Logos Hero Dynamics_HD-FULL COLOR-IZQ.png';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      if (isHome) {
        setScrolled(window.scrollY > 50);
      } else {
        setScrolled(true); // Always solid on other pages
      }
    };

    handleScroll(); // Run on mount
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHome]);

  const handleLinkClick = () => setMenuOpen(false);

  //       agregarlo despues en el return     <li onClick={handleLinkClick}><Link to="/news">News</Link></li>
  return (
    <>
      <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
          <Link to="/" className="logo-container">
          <div className="logo">
            <img src={logo} alt="HERO Dynamics" />
          </div>
          <div className="logo-text"></div>
        </Link>
            
        <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          &#9776;
        </button>
        <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
          <li onClick={handleLinkClick}>
            <Link to="/">Home</Link>
          </li> 
          <li onClick={handleLinkClick}>
            <Link to="/company">About us</Link>
          </li>
          <li onClick={handleLinkClick}>
            <Link to="/projects">SKIPER</Link>
          </li>

        </ul>
      </nav>
      {menuOpen && <div className="menu-overlay" onClick={() => setMenuOpen(false)}></div>}
    </>
  );
};

export default Navbar;
